import { useMemo } from "react";
import { MutationsObject, QueriesObject } from "./useAgreementLoading";

export const useAgreementError = (
  queries: QueriesObject,
  mutations: MutationsObject,
) => {
  return useMemo(() => {
    const queryError = queries.agreementQuery.error;
    const mutationError =
      mutations.sendQuestionnaireMutation.error ||
      mutations.rejectAgreementMutation.error ||
      mutations.confirmAgreementMutation.error ||
      mutations.commentAgreementMutation.error ||
      mutations.completeAgreementMutation.error;

    const error = queryError || mutationError;
    const isQuery = !!queryError;

    return { error, isQuery };
  }, [
    queries.agreementQuery.error,
    mutations.sendQuestionnaireMutation.error,
    mutations.rejectAgreementMutation.error,
    mutations.confirmAgreementMutation.error,
    mutations.commentAgreementMutation.error,
    mutations.completeAgreementMutation.error,
  ]);
};
